import React, { useState, useEffect, useCallback } from 'react';
import './GalleryPage.css';

function GalleryPage() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedImage, setSelectedImage] = useState(null);

  const categories = ['All', 'Wildlife', 'Landscapes', 'Beaches', 'Mountains', 'National Parks'];

  const galleryImages = [
    {
      id: 1,
      src: '/assets/imgs/destination/serengeti1.jpg',
      alt: 'Serengeti National Park',
      title: 'Serengeti Wildlife',
      category: 'Wildlife'
    },
    {
      id: 2,
      src: '/assets/imgs/destination/ngorongoro.webp',
      alt: 'Ngorongoro Crater',
      title: 'Ngorongoro Crater',
      category: 'Landscapes'
    },
    {
      id: 3,
      src: '/assets/imgs/destination/tarangire.jpg',
      alt: 'Tarangire National Park',
      title: 'Tarangire Elephants',
      category: 'Wildlife'
    },
    {
      id: 4,
      src: '/assets/imgs/destination/zanzibar.jpeg',
      alt: 'Zanzibar Beach',
      title: 'Zanzibar Paradise',
      category: 'Beaches'
    },
    {
      id: 5,
      src: '/assets/imgs/destination/lake-manyara.jpg',
      alt: 'Lake Manyara',
      title: 'Lake Manyara',
      category: 'National Parks'
    },
    {
      id: 6,
      src: '/assets/imgs/destination/arusha-national-park.jpg',
      alt: 'Arusha National Park',
      title: 'Arusha National Park',
      category: 'National Parks'
    },
    {
      id: 7,
      src: '/assets/imgs/destination/ngorongoro1.jpg',
      alt: 'Ngorongoro Landscape',
      title: 'Ngorongoro Views',
      category: 'Landscapes'
    },
    {
      id: 8,
      src: '/assets/imgs/destination/tarangire1.jpg',
      alt: 'Tarangire Landscape',
      title: 'Tarangire Scenery',
      category: 'Landscapes'
    },
    {
      id: 9,
      src: '/assets/imgs/destination/manyara.jpg',
      alt: 'Manyara Wildlife',
      title: 'Manyara Wildlife',
      category: 'Wildlife'
    },
    {
      id: 10,
      src: '/assets/imgs/destination/Mount-Kilimanjaro.jpg',
      alt: 'Mount Kilimanjaro',
      title: 'Mount Kilimanjaro',
      category: 'Mountains'
    },
    {
      id: 11,
      src: '/assets/imgs/destination/mount-meru.webp',
      alt: 'Mount Meru',
      title: 'Mount Meru',
      category: 'Mountains'
    },
    {
      id: 12,
      src: '/assets/imgs/destination/ndutu.jpg',
      alt: 'Ndutu Plains',
      title: 'Ndutu Plains',
      category: 'Wildlife'
    },
    {
      id: 13,
      src: '/assets/imgs/destination/ruaha.webp',
      alt: 'Ruaha National Park',
      title: 'Ruaha National Park',
      category: 'National Parks'
    },
    {
      id: 14,
      src: '/assets/imgs/destination/nyerere.jpg',
      alt: 'Nyerere National Park',
      title: 'Nyerere National Park',
      category: 'National Parks'
    },
    {
      id: 15,
      src: '/assets/imgs/destination/mikumi.jpg',
      alt: 'Mikumi National Park',
      title: 'Mikumi National Park',
      category: 'National Parks'
    },
    {
      id: 16,
      src: '/assets/imgs/destination/Mafia_Island_Whale_Shark_04.jpg',
      alt: 'Mafia Island',
      title: 'Mafia Island Marine Life',
      category: 'Beaches'
    },
    {
      id: 17,
      src: '/assets/imgs/destination/pemba.jpeg',
      alt: 'Pemba Island',
      title: 'Pemba Island',
      category: 'Beaches'
    },
    {
      id: 18,
      src: '/assets/imgs/destination/Gombe.jpeg',
      alt: 'Gombe Stream National Park',
      title: 'Gombe Stream National Park',
      category: 'National Parks'
    },
    {
      id: 19,
      src: '/assets/imgs/destination/Katavi-National-Parkdd.jpg',
      alt: 'Katavi National Park',
      title: 'Katavi National Park',
      category: 'National Parks'
    },
    {
      id: 20,
      src: '/assets/imgs/destination/Lake-Victoria.jpg',
      alt: 'Lake Victoria',
      title: 'Lake Victoria',
      category: 'Landscapes'
    },
    {
      id: 21,
      src: '/assets/imgs/destination/udzungwa-national-park.jpeg',
      alt: 'Udzungwa Mountains National Park',
      title: 'Udzungwa Mountains',
      category: 'Mountains'
    },
    {
      id: 22,
      src: '/assets/imgs/destination/olduvai_gorge.jpg',
      alt: 'Olduvai Gorge',
      title: 'Olduvai Gorge',
      category: 'Landscapes'
    }
  ];

  const filteredImages = selectedCategory === 'All' 
    ? galleryImages 
    : galleryImages.filter(image => image.category === selectedCategory);

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = useCallback(() => {
    setSelectedImage(null);
    document.body.style.overflow = 'unset';
  }, []);

  const navigateImage = useCallback((direction) => {
    if (!selectedImage) return;
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = currentIndex - 1 < 0 ? filteredImages.length - 1 : currentIndex - 1;
    }
    
    setSelectedImage(filteredImages[newIndex]);
  }, [selectedImage, filteredImages]);

  // Keyboard navigation for lightbox
  useEffect(() => {
    if (!selectedImage) return;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        closeLightbox();
      } else if (e.key === 'ArrowLeft') {
        navigateImage('prev');
      } else if (e.key === 'ArrowRight') {
        navigateImage('next');
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, navigateImage, closeLightbox]);

  return (
    <div className="gallery-page">
      {/* Hero Section */}
      <div className="gallery-hero">
        <div className="gallery-hero-content">
          <h1 className="gallery-hero-title">Photo Gallery</h1>
          <p className="gallery-hero-subtitle">
            Discover the breathtaking beauty of Tanzania through our collection of stunning photographs
          </p>
        </div>
      </div>

      {/* Gallery Content */}
      <div className="gallery-content">
        {/* Category Filters */}
        <div className="gallery-filters">
          {categories.map((category) => (
            <button
              key={category}
              className={`gallery-filter-btn ${selectedCategory === category ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Image Count */}
        <div className="gallery-count">
          <p>
            Showing <strong>{filteredImages.length}</strong> {filteredImages.length === 1 ? 'photo' : 'photos'}
            {selectedCategory !== 'All' && ` in ${selectedCategory}`}
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="gallery-grid-full">
          {filteredImages.map((image) => (
            <div 
              key={image.id} 
              className="gallery-item-full"
              onClick={() => openLightbox(image)}
            >
              <div className="gallery-image-wrapper-full">
                <img 
                  src={image.src} 
                  alt={image.alt}
                  className="gallery-image-full"
                  loading="lazy"
                />
                <div className="gallery-overlay-full">
                  <h3 className="gallery-image-title-full">{image.title}</h3>
                  <span className="gallery-image-category">{image.category}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredImages.length === 0 && (
          <div className="gallery-empty">
            <p>No photos found in this category.</p>
          </div>
        )}
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div className="gallery-lightbox-full" onClick={closeLightbox}>
          <button 
            className="gallery-lightbox-close-full"
            onClick={closeLightbox}
            aria-label="Close lightbox"
          >
            &times;
          </button>
          <button 
            className="gallery-lightbox-prev"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('prev');
            }}
            aria-label="Previous image"
          >
            &#8249;
          </button>
          <button 
            className="gallery-lightbox-next"
            onClick={(e) => {
              e.stopPropagation();
              navigateImage('next');
            }}
            aria-label="Next image"
          >
            &#8250;
          </button>
          <div className="gallery-lightbox-content-full" onClick={(e) => e.stopPropagation()}>
            <img 
              src={selectedImage.src} 
              alt={selectedImage.alt}
              className="gallery-lightbox-image-full"
            />
            <div className="gallery-lightbox-info">
              <p className="gallery-lightbox-title-full">{selectedImage.title}</p>
              <span className="gallery-lightbox-category">{selectedImage.category}</span>
              <p className="gallery-lightbox-counter">
                {filteredImages.findIndex(img => img.id === selectedImage.id) + 1} / {filteredImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default GalleryPage;

